// File contenente le traduzioni per l'interfaccia utente
export const uiTranslations = {
  it: {
    // Traduzioni esistenti
    model: "Modello",
    selectModel: "Seleziona modello",
    selectedNow: "Selezionato ora",
    code: "cod.",

    // Traduzioni per FamilySelector
    family: "Gamma",
    selectFamily: "Seleziona la gamma",
    loadingProducts: "Caricamento prodotti in corso...",
    noFamiliesInCategory: "Nessuna gamma in questa categoria",
    noCategories: "Nessuna categoria disponibile",

    // Traduzioni per Accordion (materiali)
    finishes: "Finiture",
    standard: "standard",
    optional: "opzionale",
    select: "Seleziona",
    standardFinishes: "standard",
    optionalFinishes: "opzionali",

    // Traduzioni delle collezioni di materiali
    materialCollections: {
      Default: "Predefinito",
      "Tessuti per termoformato": "Tessuti per termoformato",
      Verniciati: "Verniciati",
      Melaminici: "Melaminici",
      Legni: "Legni",
      Metalli: "Metalli",
      Plastiche: "Plastiche",
      melaminico: "Melaminico Laccato",
      "melaminico  legno": "Melaminico",
      metallo: "Metallo - Vernice a polvere",
      legno: "Legno",
    },

    // Traduzioni dei nomi tecnici dei materiali
    materialTypes: {
      struttura: "Struttura",
      ripiani: "Ripiani",
      imbottito: "Tessuti",
      schienale: "Schienale",
      piano: "Piano",
      inserti: "Inserti",
      plastica: "Plastica",
      top: "Top",
      alluminio: "Alluminio",
      cassetti: "Cassetti",
      canalina: "Canalina",
      ruote: "Ruote",
    },

    // Traduzioni informazioni sul prezzo - AGGIORNATE
    priceInfo: {
      estimate: "Preventivo",
      basePrice: "Prezzo Base",
      // COMMENTATE - logica del 15% rimossa temporaneamente
      // surcharge: "Sovrapprezzo (15%)",
      // surchargeNote: "Il sovrapprezzo per materiali opzionali è fisso al 15% del prezzo base.",
      pricesWithoutVAT: "Prezzi senza IVA",
      startingFrom: "a partire da",
      contactUs: "Contattaci",
      requestQuote: "Richiedi Preventivo",
      // NUOVE traduzioni per informazioni di contatto
      contactInfo: "Per ulteriori informazioni e quotazioni:",
      phone: "+39 0348 4715",
      emailSales: "vendite@dieffebi.com",
      emailMarketing: "marketing@dieffebi.com",
    },

    // NUOVE traduzioni per il modal di contatto espanso
    contactModal: {
      title: "Richiesta Preventivo Personalizzato",
      productDetails: "Dettagli Prodotto",
      category: "Categoria",
      selectedMaterials: "Materiali Selezionati",
      standardMaterial: "Standard",
      optionalMaterial: "Opzionale",
      personalData: "I Tuoi Dati",
      additionalNotes: "Note Aggiuntive",
      additionalNotesPlaceholder:
        "Specifiche aggiuntive, quantità, tempistiche di consegna...",
      name: "Nome",
      surname: "Cognome",
      email: "Email",
      phone: "Telefono",
      company: "Azienda",
      message: "Messaggio",
      cancel: "Annulla",
      submit: "Invia Richiesta",
      submitting: "Invio in corso...",
      successTitle: "Richiesta Inviata!",
      successMessage:
        "Grazie per la tua richiesta. Ti contatteremo al più presto per un preventivo personalizzato.",
      generatePDF: "Genera PDF Riassuntivo",
      downloadPDF: "Scarica PDF",
      pdfGenerated: "PDF generato con successo",

      // Messaggi automatici
      autoMessage: {
        greeting: "Salve,",
        intro: "sono interessato/a al seguente prodotto e configurazione:",
        productInfo: "DETTAGLI PRODOTTO:",
        materialsInfo: "MATERIALI SELEZIONATI:",
        priceInfo: "INFORMAZIONI PREZZO:",
        closing:
          "Vi prego di contattarmi per maggiori informazioni e per ricevere un preventivo dettagliato.",
        thanks: "Cordiali saluti",
      },
    },
    customerEmail: {
      subject: "Conferma e riepilogo della tua richiesta",
      greeting: "Gentile",
      thankYouIntro:
        "Grazie, siamo lieti di confermare che la tua richiesta è stata ricevuta con successo e sarà presto gestita dal nostro team.",
      dataSummaryTitle: "Ecco un breve riepilogo dei tuoi dati:",
      nameLabel: "Nome e Cognome:",
      emailLabel: "Email:",
      phoneLabel: "Telefono:",
      companyLabel: "Azienda:",
      notProvided: "Non fornito",
      notProvidedFemale: "Non fornita",
      attachmentNotice: "In allegato a questa email",
      attachmentText:
        "troverai il documento PDF completo che include l'elenco di tutti i dati e il riepilogo del prodotto da te configurato.",
      nextSteps:
        "Ti invieremo una notifica non appena avremo elaborato la tua richiesta.",
      contactPrompt:
        "Se hai domande o necessiti di assistenza, non esitare a contattarci.",
      closing: "Cordiali saluti,",
      teamSignature: "Il Team Dieffebi",
    },
    pdf: {
      generatedOn: "Generato il",
      madeInItaly: "MADE IN ITALY",
      gamma: "Gamma",
      code: "cod.",
      selectedMaterials: "Materiali Selezionati",
      startingFrom: "a partire da",
      clientInfo: "Informazioni Cliente",
      name: "Nome",
      surname: "Cognome",
      email: "Email",
      phone: "Tel",
      company: "Azienda",

      // Footer
      footerCompany: "Dieffebi SpA",
      footerAddress: "via Palù 36",
      footerCity: "San Vendemiano,",
      footerPostal: "31020 Treviso - Italia",
      footerPhone: "T +39 0438 4715",
      footerExportSales: "exportsales@dieffebi.com",
      footerSales: "vendite@dieffebi.com",
      footerMarketing: "marketing@dieffebi.com",
      footerWebsite: "www.dieffebi.com",
    },
    planner: {
      plannerExport: "Esporta",
      plannerImport: "Importa",
      plannerAdded: "Prodotti aggiunti",
      plannerNoProducts: "Nessun prodotto aggiunto",
      plannerLoading: "Caricamento prodotti...",
      plannerDupplicate: "Duplica",
      plannerRemove: "Rimuovi",
      plannerHeight: "Altezza",
      plannerRotation: "Rotazione",
      plannerMateriali: "Materiali",
    },
  },
  en: {
    // Traduzioni esistenti
    model: "Model",
    selectModel: "Select model",
    selectedNow: "Currently selected",
    code: "code",

    // Traduzioni per FamilySelector
    family: "Family",
    selectFamily: "Select family",
    loadingProducts: "Loading product structure...",
    noFamiliesInCategory: "No families in this category",
    noCategories: "No categories available",

    // Traduzioni per Accordion (materiali)
    finishes: "Finishes",
    standard: "standard",
    optional: "optional",
    select: "Select",
    standardFinishes: "Standard",
    optionalFinishes: "Optional",

    // Traduzioni delle collezioni di materiali
    materialCollections: {
      Default: "Default",
      "Tessuti per termoformato": "Thermoformed fabrics",
      Verniciati: "Painted",
      Melaminici: "Melamine",
      Legni: "Woods",
      Metalli: "Metals",
      Plastiche: "Plastics",
      "melaminico  legno": "Melamine",
      melaminico: "Melamine",
      metallo: "Metal",
      legno: "Wood",
    },

    // Traduzioni dei nomi tecnici dei materiali
    materialTypes: {
      struttura: "Structure",
      ripiani: "Shelves",
      imbottito: "Fabrics",
      schienale: "Backrest",
      piano: "Top",
      inserti: "Inserts",
      plastica: "Plastic",
      top: "Top",
      alluminio: "Aluminum",
      cassetti: "Drawers",
      canalina: "Cable tray",
      ruote: "Wheels",
    },

    // Traduzioni informazioni sul prezzo - AGGIORNATE
    priceInfo: {
      estimate: "Estimate",
      basePrice: "Base Price",
      // COMMENTATE - logica del 15% rimossa temporaneamente
      // surcharge: "Surcharge (15%)",
      // surchargeNote: "Surcharge for optional materials is fixed at 15% of the base price.",
      pricesWithoutVAT: "Prices without VAT",
      startingFrom: "starting from",
      contactUs: "Contact Us",
      requestQuote: "Request Quote",
      // NUOVE traduzioni per informazioni di contatto
      contactInfo: "For more information and quotes:",
      phone: "+39 0348 4715",
      emailSales: "sales@dieffebi.com",
      emailMarketing: "marketing@dieffebi.com",
    },

    // NUOVE traduzioni per il modal di contatto espanso
    contactModal: {
      title: "Custom Quote Request",
      productDetails: "Product Details",
      category: "Category",
      selectedMaterials: "Selected Materials",
      standardMaterial: "Standard",
      optionalMaterial: "Optional",
      personalData: "Your Information",
      additionalNotes: "Additional Notes",
      additionalNotesPlaceholder:
        "Additional specifications, quantities, delivery timelines...",
      name: "Name",
      surname: "Surname",
      email: "Email",
      phone: "Phone",
      company: "Company",
      message: "Message",
      cancel: "Cancel",
      submit: "Send Request",
      submitting: "Sending...",
      successTitle: "Request Sent!",
      successMessage:
        "Thank you for your request. We will contact you soon for a personalized quote.",
      generatePDF: "Generate Summary PDF",
      downloadPDF: "Download PDF",
      pdfGenerated: "PDF generated successfully",

      // Messaggi automatici
      autoMessage: {
        greeting: "Hello,",
        intro: "I am interested in the following product and configuration:",
        productInfo: "PRODUCT DETAILS:",
        materialsInfo: "SELECTED MATERIALS:",
        priceInfo: "PRICE INFORMATION:",
        closing:
          "Please contact me for more information and to receive a detailed quote.",
        thanks: "Best regards",
      },
    },
    customerEmail: {
      subject: "Confirmation and summary of your request",
      greeting: "Dear",
      thankYouIntro:
        "Thank you, we are pleased to confirm that your request has been successfully received and will soon be handled by our team.",
      dataSummaryTitle: "Here is a brief summary of your information:",
      nameLabel: "Name and Surname:",
      emailLabel: "Email:",
      phoneLabel: "Phone:",
      companyLabel: "Company:",
      notProvided: "Not provided",
      notProvidedFemale: "Not provided",
      attachmentNotice: "Attached to this email",
      attachmentText:
        "you will find the complete PDF document that includes all the details and the summary of the product you configured.",
      nextSteps:
        "We will send you a notification as soon as we have processed your request.",
      contactPrompt:
        "If you have any questions or need assistance, please do not hesitate to contact us.",
      closing: "Best regards,",
      teamSignature: "The Dieffebi Team",
    },
    pdf: {
      generatedOn: "Generated on",
      madeInItaly: "MADE IN ITALY",
      gamma: "Family",
      code: "code",
      selectedMaterials: "Selected Materials",
      startingFrom: "starting from",
      clientInfo: "Client Information",
      name: "Name",
      surname: "Surname",
      email: "Email",
      phone: "Phone",
      company: "Company",

      // Footer
      footerCompany: "Dieffebi SpA",
      footerAddress: "via Palù 36",
      footerCity: "San Vendemiano,",
      footerPostal: "31020 Treviso - Italia",
      footerPhone: "T +39 0438 4715",
      footerExportSales: "exportsales@dieffebi.com",
      footerSales: "sales@dieffebi.com",
      footerMarketing: "marketing@dieffebi.com",
      footerWebsite: "www.dieffebi.com",
    },
    planner: {
      plannerExport: "Export",
      plannerImport: "Import",
      plannerAdded: "Added products",
      plannerNoProducts: "No products added",
      plannerLoading: "Loading products...",
      plannerDupplicate: "Duplicate",
      plannerRemove: "Remove",
      plannerHeight: "Height",
      plannerRotation: "Rotation",
      plannerMateriali: "Materials",
    },
  },
  fr: {
    // Traduzioni esistenti
    model: "Modèle",
    selectModel: "Sélectionner un modèle",
    selectedNow: "Actuellement sélectionné",
    code: "code",

    // Traduzioni per FamilySelector
    family: "Gamme",
    selectFamily: "Sélectionner la gamme",
    loadingProducts: "Chargement des produits...",
    noFamiliesInCategory: "Aucune gamme dans cette catégorie",
    noCategories: "Aucune catégorie disponible",

    // Traduzioni per Accordion (materiali)
    finishes: "Finitions",
    standard: "standard",
    optional: "optionnel",
    select: "Sélectionner",
    standardFinishes: "standard",
    optionalFinishes: "optionnelles",

    // Traduzioni delle collezioni di materiali
    materialCollections: {
      Default: "Par défaut",
      "Tessuti per termoformato": "Tissus thermoformés",
      Verniciati: "Peints",
      Melaminici: "Mélamine",
      Legni: "Bois",
      Metalli: "Métaux",
      "melaminico  legno": "Mélamine",
      Plastiche: "Plastiques",
      melaminico: "Mélamine",
      metallo: "Métal",
      legno: "Bois",
    },

    // Traduzioni dei nomi tecnici dei materiali
    materialTypes: {
      struttura: "Structure",
      ripiani: "Étagères",
      imbottito: "Tissus",
      schienale: "Dossier",
      piano: "Plateau",
      inserti: "Inserts",
      plastica: "Plastique",
      top: "Dessus",
      alluminio: "Aluminium",
      cassetti: "Tiroirs",
      canalina: "Conduit de câble",
      ruote: "Roues",
    },

    // Traduzioni informazioni sul prezzo - AGGIORNATE
    priceInfo: {
      estimate: "Devis",
      basePrice: "Prix de base",
      // COMMENTATE - logica del 15% rimossa temporaneamente
      // surcharge: "Supplément (15%)",
      // surchargeNote: "Le supplément pour les matériaux optionnels est fixe à 15% du prix de base.",
      pricesWithoutVAT: "Prix hors TVA",
      startingFrom: "à partir de",
      contactUs: "Nous Contacter",
      requestQuote: "Demander un Devis",
      // NUOVE traduzioni per informazioni di contatto
      contactInfo: "Pour plus d'informations et devis:",
      phone: "+39 0348 4715",
      emailSales: "sales@dieffebi.com",
      emailMarketing: "marketing@dieffebi.com",
    },

    // NUOVE traduzioni per il modal di contatto espanso
    contactModal: {
      title: "Demande de Devis Personnalisé",
      productDetails: "Détails du Produit",
      category: "Catégorie",
      selectedMaterials: "Matériaux Sélectionnés",
      standardMaterial: "Standard",
      optionalMaterial: "Optionnel",
      personalData: "Vos Informations",
      additionalNotes: "Notes Supplémentaires",
      additionalNotesPlaceholder:
        "Spécifications supplémentaires, quantités, délais de livraison...",
      name: "Prénom",
      surname: "Nom",
      email: "Email",
      phone: "Téléphone",
      company: "Entreprise",
      message: "Message",
      cancel: "Annuler",
      submit: "Envoyer la Demande",
      submitting: "Envoi en cours...",
      successTitle: "Demande Envoyée!",
      successMessage:
        "Merci pour votre demande. Nous vous contacterons bientôt pour un devis personnalisé.",
      generatePDF: "Générer un PDF Récapitulatif",
      downloadPDF: "Télécharger PDF",
      pdfGenerated: "PDF généré avec succès",

      // Messaggi automatici
      autoMessage: {
        greeting: "Bonjour,",
        intro:
          "je suis intéressé(e) par le produit et la configuration suivants:",
        productInfo: "DÉTAILS DU PRODUIT:",
        materialsInfo: "MATÉRIAUX SÉLECTIONNÉS:",
        priceInfo: "INFORMATIONS PRIX:",
        closing:
          "Veuillez me contacter pour plus d'informations et pour recevoir un devis détaillé.",
        thanks: "Cordialement",
      },
    },
    customerEmail: {
      subject: "Confirmation et résumé de votre demande",
      greeting: "Cher/Chère",
      thankYouIntro:
        "Merci, nous sommes heureux de confirmer que votre demande a été reçue avec succès et sera bientôt traitée par notre équipe.",
      dataSummaryTitle: "Voici un bref résumé de vos informations:",
      nameLabel: "Nom et Prénom:",
      emailLabel: "Email:",
      phoneLabel: "Téléphone:",
      companyLabel: "Entreprise:",
      notProvided: "Non fourni",
      notProvidedFemale: "Non fournie",
      attachmentNotice: "En pièce jointe à cet email",
      attachmentText:
        "vous trouverez le document PDF complet qui comprend tous les détails et le résumé du produit que vous avez configuré.",
      nextSteps:
        "Nous vous enverrons une notification dès que nous aurons traité votre demande.",
      contactPrompt:
        "Si vous avez des questions ou besoin d'assistance, n'hésitez pas à nous contacter.",
      closing: "Cordialement,",
      teamSignature: "L'équipe Dieffebi",
    },
    pdf: {
      generatedOn: "Généré le",
      madeInItaly: "FABRIQUÉ EN ITALIE",
      gamma: "Gamme",
      code: "code",
      selectedMaterials: "Matériaux Sélectionnés",
      startingFrom: "à partir de",
      clientInfo: "Informations Client",
      name: "Prénom",
      surname: "Nom",
      email: "Email",
      phone: "Tél",
      company: "Entreprise",

      // Footer
      footerCompany: "Dieffebi SpA",
      footerAddress: "via Palù 36",
      footerCity: "San Vendemiano,",
      footerPostal: "31020 Treviso - Italia",
      footerPhone: "T +39 0438 4715",
      footerExportSales: "exportsales@dieffebi.com",
      footerSales: "sales@dieffebi.com",
      footerMarketing: "marketing@dieffebi.com",
      footerWebsite: "www.dieffebi.com",
    },
    planner: {
      plannerExport: "Exporter",
      plannerImport: "Importer",
      plannerAdded: "Produits ajoutés",
      plannerNoProducts: "Aucun produit ajouté",
      plannerLoading: "Chargement des produits...",
      plannerDupplicate: "Dupliquer",
      plannerRemove: "Supprimer",
      plannerHeight: "Hauteur",
      plannerRotation: "Rotation",
      plannerMateriali: "Matériaux",
    },
  },
  de: {
    // Traduzioni esistenti
    model: "Modell",
    selectModel: "Modell auswählen",
    selectedNow: "Aktuell ausgewählt",
    code: "code",

    // Traduzioni per FamilySelector
    family: "Produktfamilie",
    selectFamily: "Produktfamilie auswählen",
    loadingProducts: "Produktstruktur wird geladen...",
    noFamiliesInCategory: "Keine Familien in dieser Kategorie",
    noCategories: "Keine Kategorien verfügbar",

    // Traduzioni per Accordion (materiali)
    finishes: "Oberflächen",
    standard: "standard",
    optional: "optional",
    select: "Auswählen",
    standardFinishes: "Standardaus",
    optionalFinishes: "Optionale",

    // Traduzioni delle collezioni di materiali
    materialCollections: {
      Default: "Standard",
      "Tessuti per termoformato": "Thermogeformte Stoffe",
      Verniciati: "Lackiert",
      Melaminici: "Melamin",
      Legni: "Holz",
      Metalli: "Metalle",
      Plastiche: "Kunststoffe",
      "melaminico  legno": "Melamin",
      melaminico: "Melamin",
      metallo: "Metall",
      legno: "Holz",
    },

    // Traduzioni dei nomi tecnici dei materiali
    materialTypes: {
      struttura: "Struktur",
      ripiani: "Regale",
      imbottito: "Polsterung",
      schienale: "Rückenlehne",
      piano: "Oberfläche",
      inserti: "Einsätze",
      plastica: "Kunststoff",
      top: "Oberseite",
      alluminio: "Aluminium",
      cassetti: "Schubladen",
      canalina: "Kabelkanal",
      ruote: "Räder",
    },

    // Traduzioni informazioni sul prezzo - AGGIORNATE
    priceInfo: {
      estimate: "Kostenvoranschlag",
      basePrice: "Grundpreis",
      // COMMENTATE - logica del 15% rimossa temporaneamente
      // surcharge: "Aufpreis (15%)",
      // surchargeNote: "Der Aufpreis für optionale Materialien ist fest bei 15% des Grundpreises.",
      pricesWithoutVAT: "Preise ohne MwSt.",
      startingFrom: "ab",
      contactUs: "Kontakt",
      requestQuote: "Angebot Anfordern",
      // NUOVE traduzioni per informazioni di contatto
      contactInfo: "Für weitere Informationen und Angebote:",
      phone: "+39 0348 4715",
      emailSales: "sales@dieffebi.com",
      emailMarketing: "marketing@dieffebi.com",
    },

    // NUOVE traduzioni per il modal di contatto espanso
    contactModal: {
      title: "Individuelle Angebotsanfrage",
      productDetails: "Produktdetails",
      category: "Kategorie",
      selectedMaterials: "Ausgewählte Materialien",
      standardMaterial: "Standard",
      optionalMaterial: "Optional",
      personalData: "Ihre Daten",
      additionalNotes: "Zusätzliche Hinweise",
      additionalNotesPlaceholder:
        "Zusätzliche Spezifikationen, Mengen, Lieferzeiten...",
      name: "Vorname",
      surname: "Nachname",
      email: "E-Mail",
      phone: "Telefon",
      company: "Unternehmen",
      message: "Nachricht",
      cancel: "Abbrechen",
      submit: "Anfrage Senden",
      submitting: "Wird gesendet...",
      successTitle: "Anfrage Gesendet!",
      successMessage:
        "Vielen Dank für Ihre Anfrage. Wir werden Sie bald für ein personalisiertes Angebot kontaktieren.",
      generatePDF: "Zusammenfassung PDF Generieren",
      downloadPDF: "PDF Herunterladen",
      pdfGenerated: "PDF erfolgreich generiert",

      // Messaggi automatici
      autoMessage: {
        greeting: "Hallo,",
        intro:
          "ich interessiere mich für das folgende Produkt und die Konfiguration:",
        productInfo: "PRODUKTDETAILS:",
        materialsInfo: "AUSGEWÄHLTE MATERIALIEN:",
        priceInfo: "PREISINFORMATIONEN:",
        closing:
          "Bitte kontaktieren Sie mich für weitere Informationen und um ein detailliertes Angebot zu erhalten.",
        thanks: "Mit freundlichen Grüßen",
      },
    },
    customerEmail: {
      subject: "Bestätigung und Zusammenfassung Ihrer Anfrage",
      greeting: "Sehr geehrte/r",
      thankYouIntro:
        "Vielen Dank, wir freuen uns, Ihnen bestätigen zu können, dass Ihre Anfrage erfolgreich eingegangen ist und bald von unserem Team bearbeitet wird.",
      dataSummaryTitle: "Hier ist eine kurze Zusammenfassung Ihrer Daten:",
      nameLabel: "Name und Nachname:",
      emailLabel: "E-Mail:",
      phoneLabel: "Telefon:",
      companyLabel: "Unternehmen:",
      notProvided: "Nicht angegeben",
      notProvidedFemale: "Nicht angegeben",
      attachmentNotice: "Im Anhang dieser E-Mail",
      attachmentText:
        "finden Sie das vollständige PDF-Dokument mit allen Details und der Zusammenfassung des von Ihnen konfigurierten Produkts.",
      nextSteps:
        "Wir werden Sie benachrichtigen, sobald wir Ihre Anfrage bearbeitet haben.",
      contactPrompt:
        "Wenn Sie Fragen haben oder Unterstützung benötigen, zögern Sie bitte nicht, uns zu kontaktieren.",
      closing: "Mit freundlichen Grüßen,",
      teamSignature: "Das Dieffebi Team",
    },
    pdf: {
      generatedOn: "Generiert am",
      madeInItaly: "MADE IN ITALY",
      gamma: "Produktfamilie",
      code: "code",
      selectedMaterials: "Ausgewählte Materialien",
      startingFrom: "ab",
      clientInfo: "Kundeninformationen",
      name: "Vorname",
      surname: "Nachname",
      email: "E-Mail",
      phone: "Tel",
      company: "Unternehmen",

      // Footer
      footerCompany: "Dieffebi SpA",
      footerAddress: "via Palù 36",
      footerCity: "San Vendemiano,",
      footerPostal: "31020 Treviso - Italia",
      footerPhone: "T +39 0438 4715",
      footerExportSales: "exportsales@dieffebi.com",
      footerSales: "sales@dieffebi.com",
      footerMarketing: "marketing@dieffebi.com",
      footerWebsite: "www.dieffebi.com",
    },
    planner: {
      plannerExport: "Exportieren",
      plannerImport: "Importieren",
      plannerAdded: "Hinzugefügte Produkte",
      plannerNoProducts: "Keine Produkte hinzugefügt",
      plannerLoading: "Produkte werden geladen...",
      plannerDupplicate: "Duplizieren",
      plannerRemove: "Entfernen",
      plannerHeight: "Höhe",
      plannerRotation: "Drehung",
      plannerMateriali: "Materialien",
    },
  },
};

// Funzione di supporto per ottenere le traduzioni nella lingua specificata
export const getTranslations = (language) => {
  return uiTranslations[language] || uiTranslations.it; // Fallback all'italiano se la lingua non esiste
};
